export default __webpack_public_path__ + "static/2-d5df71810ebca4be8ff43d985ac5bc67.png";